var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_cop",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 46,
    height: 46
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22.65,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_cop)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.35,
    width: 46,
    height: 22.65,
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 23,
    width: 46,
    height: 11.325,
    fill: "#003893"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 34.325,
    width: 46,
    height: 11.325,
    fill: "#CE1126"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCop);
export default __webpack_public_path__ + "static/media/COP.bd8627b0c3f368d8e7bf0887b4fdfd77.svg";
export { ForwardRef as ReactComponent };